import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['VotingReview', 'VotingQuestion', 'VotingAnswer'] });

const apiVotingSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getReviewVote: builder.query({
      query: ({ ean, id }) => ({
        url: `/community/products/${ean}/reviews/${id}/vote/`,
      }),
      providesTags: ['VotingReview'],
    }),
    getQuestionVote: builder.query({
      query: ({ ean, id }) => ({
        url: `/community/products/${ean}/questions/${id}/vote/`,
      }),
      providesTags: ['VotingQuestion'],
    }),
    getAnswerVote: builder.query({
      query: ({ ean, Q, id }) => ({
        url: `/community/products/${ean}/questions/${Q}/answers/${id}/vote/`,
      }),
      providesTags: ['VotingAnswer'],
    }),
    updateReviewVote: builder.mutation({
      query: ({ ean, id, payload }) => ({
        url: `/community/products/${ean}/reviews/${id}/vote/`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['VotingReview'],
    }),
    updateQuestionVote: builder.mutation({
      query: ({ ean, id, payload }) => ({
        url: `/community/products/${ean}/questions/${id}/vote/`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['VotingQuestion'],
    }),
    updateAnswerVote: builder.mutation({
      query: ({ ean, Q, id, payload }) => ({
        url: `/community/products/${ean}/questions/${Q}/answers/${id}/vote/`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['VotingAnswer'],
    }),
  }),
});

export const { useGetReviewVoteQuery, useGetQuestionVoteQuery, useGetAnswerVoteQuery, useUpdateReviewVoteMutation, useUpdateQuestionVoteMutation, useUpdateAnswerVoteMutation } = apiVotingSlice;

export default apiVotingSlice;
